function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { getRefName } from './utils';
import SubMixin from './mixins/sub';
import BaseTable from './baseTable.js';
export default {
  name: 'BodyTable',
  components: {
    BaseTable: BaseTable
  },
  mixins: [SubMixin],
  props: {
    hasHead: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    refName: function refName() {
      return getRefName(this.fixed, 'bodyTableRef');
    },
    style: function () {
      var isFixedHeader = this.isFixedHeader,
          fixed = this.fixed,
          bodyStyle = this.bodyStyle,
          scroll = this.scroll,
          scrollBarW = this.scrollBarW;
      var style = {};

      if (scroll.x && !fixed) {
        style.overflowX = 'auto';
      }

      if (scroll.y && !fixed) {
        // if (scroll.y) {
        style.maxHeight = typeof scroll.y === 'boolean' ? scroll.y : "".concat(scroll.y, "px");
        style.overflowY = 'scroll';
      }

      if (scroll.x || scroll.y) {
        // bug retina ,chrome overflow auto
        // https://bibwild.wordpress.com/2015/07/04/long-standing-bug-in-chrome-webkit-on-page-not-being-drawn-scrollauto-retina/
        style.webkitTransform = 'translate3d(0,0,0)';
      }

      style = _objectSpread({}, style, {}, bodyStyle); // header fixed

      if (isFixedHeader && fixed && scrollBarW > 0) {
        style.marginBottom = "-".concat(scrollBarW, "px");
        style.paddingBottom = 0;
      }

      return style;
    },
    fixedInnerStyle: function fixedInnerStyle() {
      var scroll = this.scroll;
      var style = {};

      if (scroll.y) {
        style.maxHeight = typeof scroll.y === 'boolean' ? scroll.y : "".concat(scroll.y, "px");
        style.overflowY = 'scroll';
      }

      return style;
    },
    hasFixedElement: function hasFixedElement() {
      var fixed = this.fixed,
          isAnyColumnsLeftFixed = this.isAnyColumnsLeftFixed,
          isAnyColumnsRightFixed = this.isAnyColumnsRightFixed;

      if (fixed === 'left') {
        return isAnyColumnsLeftFixed;
      } else if (fixed === 'right') {
        return isAnyColumnsRightFixed;
      }

      return false;
    }
  },
  mounted: function mounted() {
    var $refs = this.$refs,
        refName = this.refName;
    this.saveRef(refName, $refs[refName]);
  },
  methods: {
    onScroll: function onScroll(e) {
      e.stopPropagation();
      this.$emit('body-scroll', e);
    }
  },
  render: function render() {
    var h = arguments[0];
    var prefixCls = this.prefixCls,
        hasHead = this.hasHead,
        fixed = this.fixed,
        refName = this.refName,
        style = this.style,
        fixedInnerStyle = this.fixedInnerStyle,
        hasFixedElement = this.hasFixedElement,
        onScroll = this.onScroll;
    var table = h("base-table", {
      "attrs": {
        "has-body": true,
        "has-head": hasHead,
        "fixed": fixed
      }
    }); // left and right fixed时渲染列表

    if (fixed) {
      return hasFixedElement ? h("div", {
        "class": "".concat(prefixCls, "-body-outer"),
        "style": style
      }, [h("div", {
        "ref": refName,
        "class": "".concat(prefixCls, "-body-inner"),
        "style": fixedInnerStyle,
        "on": {
          "scroll": onScroll
        }
      }, [table])]) : null;
    }

    return h("div", {
      "ref": refName,
      "class": "".concat(prefixCls, "-body"),
      "style": style,
      "on": {
        "scroll": onScroll
      }
    }, [table]);
  }
};